import { Injectable } from '@angular/core';
import { PartyRequestModel } from '../_models/request/PartyRequestModel';
import { SearchPartyRequestModel } from '../_models/request/SearchPartyRequestModel';
import { ApiSendService } from '@global-services/ApiSend.service';
import { ApiUrlEnum } from '@global-models/ApiUrlEnum';
import { SearchRequestModel } from 'app/vbt-ticari/common/_models/SearchRequestModel';

@Injectable()
export class CustomerService {

  constructor(private _apiservice: ApiSendService) {
  }

  public GetCustomerListByIdentificationNumber(IdentificationNumber: String) {
    return this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, '/api/Party/GetCustomerListByIdentificationNumber?IdentificationNumber=' + IdentificationNumber);
  }

  public Delete(id: number) {
    return this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, '/api/Party/Delete?id=' + id);
  }

  public Update(model: PartyRequestModel) {
    return this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Party/Update', model);
  }

  public Add(model: PartyRequestModel) {
    return this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Party/Add', model);
  }

  public AddBranch(model: PartyRequestModel) {
    return this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Party/AddBranch', model);
  }

  public GetPartyList(model: SearchRequestModel<SearchPartyRequestModel>) {
    const url = '/api/Party/GetPartyList?PartyName=' +
      model.Query.PartyName +
      '&PartyTypeId=' + model.Query.PartyTypeId +
      '&Skip=' + model.Skip +
      '&Take=' + model.Take +
      '&OrderByName=' + model.OrderByName +
      '&OrderByType=' + model.OrderByType +
      '&IdentificationNumber=' + model.Query.IdentificationNumber;

    return this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, url);
  }
  public Get(id: number) {
    return this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, '/api/Party/Get?id=' + id);
  }

  public GetPartyListByNameAndType(partyName: string) {
    return this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, '/api/Party/GetPartyListByNameAndType?partyName=' + partyName + '&partyTypeId=1');
  }

  // Global Search Cari-Firma listesi
  public GetPartyFirmList(searchKey: string) {
    return this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, '/api/PartyFirm/GetPartyFirmList?searchKey=' + searchKey);
  }

  public GetPartyListByTaxIdentityNumberFromFlerpi(identityOrTaxNumber: string) {
    return this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, '/api/Party/GetPartyListByTaxIdentityNumberFromFlerpi?TaxIdentityNumber=' + identityOrTaxNumber);
  }

}
